<template>
  <div class="category-drop-down" dir="rtl">
    <div class="row" v-if="categories.length">
      <div class="col-sm-6">
        <label class="label">دسته بندی</label>
        <multiselect
          v-model="category"
          placeholder="دسته بندی را جستجو کنید"
          track-by="category_id"
          label="category"
          :options="categories"
          selectLabel="برای انتخاب دسته بندی کلیک کنید"
          selectedLabel="انتخاب شده"
          deselectLabel="برای حذف دسته بندی کلیک کنید"
        >
          <span slot="noResult">مورد مشابه یافت نشد و یا قبلا اضافه شده</span>
        </multiselect>
      </div>
      <div class="col-sm-6">
        <label class="label">زیردسته</label>
        <multiselect
          v-model="subcategory"
          placeholder="زیردسته را جستجو کنید"
          track-by="subcategory_id"
          label="subcategory"
          :options="subCategories"
          selectLabel="برای انتخاب زیردسته کلیک کنید"
          selectedLabel="انتخاب شده"
          deselectLabel="برای حذف زیردسته کلیک کنید"
        >
          <span slot="noResult">مورد مشابه یافت نشد و یا قبلا اضافه شده</span>
        </multiselect>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "drop-down",
  props: ["category_id",'subcategory_id', "isEdit"],
  mounted() {

    this.setValue();
  },
  computed: {
    categories() {
      return this.$store.state.categories.filterCat;
    },
    subCategories() {
      if (!this.category) return [];
      return this.categories.filter(
        c => c.category_id === this.category.category_id
      )[0].sub;
    }
  },
  data() {
    return {
      category: null,
      subcategory: null
    };
  },
  watch: {
    category(val) {
      if (val && this.subcategory) {
        this.emitValue();
      }
    },
    subcategory(val) {
      if (val && this.category) {
        this.emitValue();
      }
    }
  },
  methods: {
    setValue() {
      if (this.isEdit) {
        this.category = this.categories.filter(
          c => c.category_id === this.category_id
        )[0];
        this.subcategory = this.subCategories.filter(
          c => c.subcategory_id === this.subcategory_id
        )[0];
      }
    },
    emitValue() {
        this.$emit("input", {category_id:this.category.category_id , subcategory_id:this.subcategory.subcategory_id });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/min-component/category-drop-down/fullmode.vue